import Vue from 'vue'

export default {
  getListadoGeneros () {
    return new Promise((resolve, reject) => {
      Vue.http.get(
        'api/genders',
        {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          }
        }
      ).then((response) => {
        resolve(response.data)
      }, response => {
        resolve(response.data)
      })
    })
  }

}



// WEBPACK FOOTER //
// ./src/js/genero.js